import axios from '@/http/api'
//4.1.3 获取未读消息通知个数
export const selectEquipmentInfoNum = data => {
  return axios({
    url: '/consoleGateway/equipmentController/selectEquipmentInfoNum',
    method: 'post',
    data
  })
}
//4.1.4 分页获取消息通知列表
export const selectEquipmentInfoList = data => {
  return axios({
    url: '/consoleGateway/equipmentController/selectEquipmentInfoList',
    method: 'post',
    data
  })
}
//4.1.1 删除消息通知
export const deleteEquipmentInfo = data => {
  return axios({
    url: '/consoleGateway/equipmentController/deleteEquipmentInfo',
    method: 'post',
    data
  })
}
//4.1.2 修改消息通知状态
export const updateEquipmentInfoState = data => {
  return axios({
    url: '/consoleGateway/equipmentController/updateEquipmentInfoState',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/information.js